import script from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"

import "./manage-profile.vue?vue&type=style&index=0&id=47b50aa9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b50aa9"]])

export default __exports__